<template>
  <v-container>
    <v-row
      v-if="$vuetify.breakpoint.smAndUp"
      align="center"
      justify="space-between"
      no-gutters
      class="mb-2"
    >
      <v-row align="center" no-gutters>
        <ProductionDialog></ProductionDialog>
        <InventoryWasteDialog></InventoryWasteDialog>
      </v-row>

      <v-btn
        :class="{
          'ml-2': !$vuetify.breakpoint.xsOnly,
          'my-2': $vuetify.breakpoint.xsOnly
        }"
        :block="$vuetify.breakpoint.xsOnly"
        :to="{ name: 'InventoryViewer', params: { date: null } }"
      >
        <v-icon small left>fa-external-link-alt</v-icon>
        Exporter
      </v-btn>
    </v-row>
    <v-row align="center" no-gutters dense>
      <span class="overline">Mode d'affichage</span>
      <v-btn
        :small="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xsOnly"
        text
        @click="showAll = false"
        :color="showAll === false ? 'success' : ''"
      >
        <v-icon
          :size="$vuetify.breakpoint.smAndUp ? '15px' : 'medium'"
          :left="$vuetify.breakpoint.smAndUp"
          >mdi-view-dashboard</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">Emplacements</span>
      </v-btn>
      <v-btn
        :small="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xsOnly"
        text
        @click="showAll = true"
        :color="showAll === true ? 'success' : ''"
      >
        <v-icon
          :size="$vuetify.breakpoint.smAndUp ? 'x-small' : 'medium'"
          :left="$vuetify.breakpoint.smAndUp"
          >fa-boxes</v-icon
        >
        <span v-show="$vuetify.breakpoint.smAndUp">Complet</span>
      </v-btn>
      <v-row dense justify="end" no-gutters v-if="$vuetify.breakpoint.xsOnly">
        <v-menu
          ref="menu"
          v-model="menu"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon text v-on="on">
              <v-icon v-if="menu === true">far fa-caret-square-up</v-icon>
              <v-icon v-else>far fa-caret-square-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <ProductionDialog list></ProductionDialog>
            <InventoryWasteDialog list></InventoryWasteDialog>
            <v-list-item
              :to="{ name: 'InventoryViewer', params: { date: null } }"
            >
              <v-list-item-icon>
                <v-icon>fa-external-link-alt</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Exporter
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-row>
    <v-card>
      <v-card-text>
        <v-row align="center" no-gutters class="mb-2">
          <InventoryTemplateTagsEditor
            v-model="tags"
            :icon="false"
          ></InventoryTemplateTagsEditor>
        </v-row>
        <v-row align="center" no-gutters class="mb-2">
          <v-text-field
            label="Recherche"
            filled
            class="no-before"
            dense
            hide-details
            v-model="search"
            clearable
          ></v-text-field>
        </v-row>
        <InventoryGrid
          :loading="loading"
          :filter="tags"
          :show-search="false"
          :search-props="search"
          v-if="getInventoryTemplate === undefined || showAll === true"
          @update="updateHandler"
        ></InventoryGrid>
        <InventoryRecordViewer
          v-else
          ref="inventoryRecordViewer"
          :loading="loading"
          :template.sync="template"
          :tags="tags"
          :edit="edit"
          :search="search"
          @update="updateHandler"
        ></InventoryRecordViewer>
      </v-card-text>
    </v-card>
    <v-row align="center" justify="end" no-gutters class="my-2">
      <InventoryRecordLocalHistory></InventoryRecordLocalHistory>
      <v-btn
        small
        color="success"
        @click="saveUpdateList"
        :disabled="updateList.length === 0"
      >
        <v-icon small left>fa-save</v-icon> Enregistrement manuel
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import {
  InventoryGrid,
  InventoryTemplateTagsEditor,
  InventoryRecordViewer,
  InventoryWasteDialog,
  ProductionDialog,
  InventoryRecordLocalHistory
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "InventoryIndex",
  components: {
    InventoryGrid,
    InventoryTemplateTagsEditor,
    InventoryRecordViewer,
    InventoryWasteDialog,
    ProductionDialog,
    InventoryRecordLocalHistory
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getOrganisationId",
      "getIsAdmin",
      "getInventoryTemplate"
    ])
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      optionDialog: false,
      loading: false,
      tags: [],
      template: [],
      mode: false,
      date: null,
      menu: false,
      edit: false,
      search: "",
      updateList: [],
      showAll: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.template = [];
        await Promise.all([
          this.$store.dispatch("loadRecipes", {
            organisation: this.getOrganisationId
          }),
          this.$store.dispatch("loadProducts", {
            organisation: this.getOrganisationId
          }),
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          }),
          this.$store.dispatch("loadInventoryTemplates", {
            store: this.getStoreId
          }),
          this.$store.dispatch("loadWasteCauses", {
            store: this.getStoreId
          }),
          this.$store.dispatch("loadTagCategories"),
          this.$store.dispatch("loadInventoryTagOrders")
        ]);
        if (this.getInventoryTemplate !== undefined) {
          this.template = this.getInventoryTemplate.templates;
        }
      } finally {
        this.loading = false;
      }
    },
    async saveTemplate() {
      this.$refs.inventoryRecordViewer.saveOrder();
    },
    async updateHandler(data) {
      this.updateList.push(data);
    },
    async saveUpdateList() {
      try {
        let recordToUpdate = [];
        this.$store.dispatch("slo");
        this.updateList.forEach(x => recordToUpdate.push(this.saveUpdate(x)));
        await Promise.all(recordToUpdate);
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async saveUpdate(d) {
      const res = await api.postInventoryRecordNormalHandler(d);
      this.$store.dispatch("updateInventoryRecord", res);
    }
  },
  watch: {
    getStoreId() {
      this.getData();
    },
    getOrganisationId() {
      this.getData();
    }
  }
};
</script>

<style lang="scss" scoped></style>
